const localApi = "http://localhost:5050/api";
const productionApi = "https://api.mozogroup.in/api";
const browserHost = typeof window !== "undefined" ? window.location.hostname : "";

export const API_BASE = (
 process.env.REACT_APP_API_URL ||
 (browserHost === "localhost" || browserHost === "127.0.0.1" ? localApi : productionApi)
).replace(/\/$/, "");

export function authHeaders(token) {
 return token ? { Authorization: `Bearer ${token}` } : {};
}

export function isFormDataBody(body) {
 return typeof FormData !== "undefined" && body instanceof FormData;
}

export async function apiRequest(path, options = {}, token = "") {
 const isFormData = isFormDataBody(options.body);
 const response = await fetch(`${API_BASE}${path}`, {
  ...options,
  headers: {
   ...(!isFormData && options.body ? { "Content-Type": "application/json" } : {}),
   ...authHeaders(token),
   ...(options.headers || {}),
  },
 });
 const data = await response.json().catch(() => ({}));

 if (!response.ok) {
  throw new Error(data.error || "API request failed");
 }

 return data;
}
